import axios from 'axios'
import moment from 'moment'

import config from '../../config'
import store from '../../store'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import {ELASTIC_TOKEN} from '../../config'

async function elaticsearchQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<odor-*>/_search`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/json'
      }
    }
  )
  return result
}

async function elaticsearchMutiQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<odor-*>/_msearch`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/x-ndjson'
      }
    }
  )
  return result
}

export async function getOdor(condition = {}) {
  if (Utils.isEmptyObject(condition)) {
    return []
  }

  const odorIds = Utils.isEmptyObject(condition.identifierId) ? [] : condition.identifierId
  const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'd' : condition.unit
  const queryTime = Utils.isEmptyObject(condition.value) ? -1 : condition.value
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime

  const lte = endTime ? moment(endTime) : moment()
  const gte = startTime ? moment(startTime) : moment().subtract(queryTime, queryTimeUnit) // 萬一沒有起訖時間則搜尋一天前

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: { // https://discuss.elastic.co/t/multiple-range-filters-for-same-field/73898/2
              '@timestamp': {
                gte: gte.valueOf(),
                lte: lte.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
          {
            range: {
              'message.data.odor': {
                gte: CONST.ODOR_CRTICAL_POINT
              }
            }
          }
        ]
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: CONST.ELK_SEARCH_MAX_SIZE
  }

  // ------filter odorIds id
  if (!Utils.isEmptyObject(odorIds)) {
    const odorIdString = Utils.getESQueryOdorNiloId(odorIds)
    const queryOdorIds = {
      query_string: {
        analyze_wildcard: true,
        query: odorIdString
      }
    }
    query.query.bool.filter.push(queryOdorIds)
  }

  const result = await elaticsearchQuery(query)
  return Utils.isEmptyObject(result)? [] : result.data.hits.hits
}